/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminUpdateUserEmailRequest
 */
export interface AdminUpdateUserEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateUserEmailRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateUserEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the AdminUpdateUserEmailRequest interface.
 */
export function instanceOfAdminUpdateUserEmailRequest(value: object): value is AdminUpdateUserEmailRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AdminUpdateUserEmailRequestFromJSON(json: any): AdminUpdateUserEmailRequest {
    return AdminUpdateUserEmailRequestFromJSONTyped(json, false);
}

export function AdminUpdateUserEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateUserEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
    };
}

export function AdminUpdateUserEmailRequestToJSON(json: any): AdminUpdateUserEmailRequest {
    return AdminUpdateUserEmailRequestToJSONTyped(json, false);
}

export function AdminUpdateUserEmailRequestToJSONTyped(value?: AdminUpdateUserEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
    };
}

